import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/og_logo.webp';

function AppNavbar({ className }) {
  const location = useLocation();

  return (
    <Navbar bg="dark" expand="lg" className={`ogs-navbar ${className || ''}`}>
      <Container>
        <Navbar.Brand as={Link} to="/" className="d-flex align-items-center ogs-navbar-brand">
          <img src={logo} alt="OGS Logo" className="ogs-navbar-logo me-3" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="main-navbar-nav" />
        <Navbar.Collapse id="main-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link
              as={Link}
              to="/"
              className={location.pathname === '/' ? 'ogs-active-link' : ''}
            >
              Home
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/about"
              className={location.pathname === '/about' ? 'ogs-active-link' : ''}
            >
              About Us
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/vision"
              className={location.pathname === '/vision' ? 'ogs-active-link' : ''}
            >
              Vision & Mission
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/contact"
              className={location.pathname === '/contact' ? 'ogs-active-link' : ''}
            >
              Contact Us
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default AppNavbar;